import { render } from "./App.vue?vue&type=template&id=104d7bdd"
const script = {}

import "./App.vue?vue&type=style&index=0&id=104d7bdd&lang=scss"
script.render = render

export default script